export default function ChevronDownIcon() {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.5 5.5L8.5 10.5L13.5 5.5"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  )
}
